// src/services/incode.js
import { create } from "@incodetech/welcome";

const apiURL = process.env.REACT_APP_INCODE_API_URL;
const clientId = process.env.REACT_APP_INCODE_CLIENT_ID;

const incode = create({
  clientId: clientId,
  apiURL: apiURL,
  theme: {
    // Puedes personalizar el tema aquí, por ejemplo:
    main: "#000", // Color principal
    mainButton: {
      borderRadius: "4px",
      color: "#fff",
      border: "1px solid #000",
    },
  },
});

export default incode;
